// removed by extract-text-webpack-plugin
module.exports = {"Prompt":"_3nX-7K0-dG6hNlp0PCP_C0","Prompt__question":"_32NOKDhwAunzZ7GoTYYlVa","Prompt__textarea":"_1ZcH4aEYEKv3HtnJJNouHF","Prompt__buttons":"pGAyz-JdZiI8DT4YTDDW3","Prompt__button":"_2nQHEhxZRSBemEpiUbe9pS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/Prompt.scss
// module id = 2385
// module chunks = 0